export default function Header(){
	const banner = "<MP/>"
	return(
		<header>
			<h1 className="logo">{banner}</h1>
		</header>
	)
}